<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="filter" :model="filter"  :label-width="100" label-position="right" @submit.native.prevent>
        <Row type="flex">
          <Col v-bind="grid">
            <FormItem label="搜索内容："  label-for="key">
              <Input search enter-button placeholder="请输入耳标编号搜索" clearable v-model="filter.search" @on-search="search" @on-clear="searchClear">
              </Input>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="猪只类别："  label-for="key">
              <Select v-model="filter.pig_type_id" class="perW100" @on-change="select">
                <Option :value="0">全部</Option>
                <Option v-for="(item, key) in pigTypeList" :value="key" :key="key">{{item}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="猪只品种："  label-for="key">
              <Select v-model="filter.pig_variety_id" class="perW100" @on-change="select">
                <Option :value="0">全部</Option>
                <Option v-for="(item, key) in pigVarietyList" :value="key" :key="key">{{item}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="筛选圈舍：">
              <Select v-model="filter.pig_house_id" class="perW100" @on-change="select">
                <Option :value="0">全部</Option>
                <Option v-for="(item, key) in pigHouseList" :key="key" :value="key" >{{item}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="创建时间：" prop="key" label-for="key">
              <DatePicker type="daterange" :value="filter.ctime" confirm placeholder="请选择查询时间段" style="width: 100%" @on-ok="dateOk" @on-change="dateChange" @on-clear="dateClear"></DatePicker>
            </FormItem>
          </Col>
          <Col style="margin-left: 20px">
            <Button type="primary" icon="ios-cloud-download-outline" @click="exportTableData" :loading="exportLoading">报告导出</Button>
          </Col>
        </Row>
        <Row type="flex" style="flex-wrap: nowrap;justify-content: space-between;margin: 20px 20px 0 20px">

          <Col style="margin: 0 10px">
            <Button type="primary" icon="md-add" @click="add">添加</Button>
          </Col>

        </Row>
      </Form>

      <Table :columns="columns" stripe  :data="tableData" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >

        <template slot-scope="{ row, index }" slot="action">
          <a @click="info(row.pig_harmless_death_id)">查看</a>
          <Divider type="vertical" />
          <a @click="edit(row.pig_harmless_death_id)">编辑</a>
          <Divider type="vertical" />
          <a @click="del(row.pig_harmless_death_id)">删除</a>
        </template>

      </Table>
      <Page :total="tableCount" :current="filter.page" :page-size="filter.limit" class="acea-row row-right page" show-total  @on-change="changePage"></Page>
    </Card>
  </div>
</template>

<script>
import { pigHarmlessDeathListApi, pigHarmlessDeathDelApi } from '@/api/pigFarm/pigHarmlessDeath'
import { pigTypeAllApi } from '@/api/pigFarm/pigType'
import { pigVarietyAllApi } from '@/api/pigFarm/pigVariety'
import {pigHouseAllApi} from "@/api/pigFarm/pigHouse";

export default {
  name: 'pigHarmlessDeathList',
  inject: ['reload'],
  data () {
    return {
      grid: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 7,
        xl: 7
      },
      filter: {
        page: 1,
        limit: 10,
        ctime: [],
        export: 0,
        search: '',
        pig_house_id: 0,
        pig_type_id: 0,
        pig_variety_id: 0,
      },
      pigHouseList: [],
      pigTypeList: [],
      pigVarietyList: [],
      tableData: [],
      tableCount: 0,
      loading: false,
      exportLoading: false,
      columns: [
        {
          title: '猪只类别',
          key: 'pig_type_name',
          minWidth: 100
        },
        {
          title: '猪只品种',
          key: 'pig_variety_name',
          minWidth: 100
        },
        {
          title: '所属圈舍',
          key: 'pig_house_name',
          minWidth: 100
        },
        {
          title: '耳标编号',
          key: 'tag_sn',
          minWidth: 180
        },
        {
          title: '死亡原因',
          key: 'reason',
          ellipsis: true,
          minWidth: 180
        },
        {
          title: '死亡时间',
          key: 'date',
          minWidth: 100
        },
        {
          title: '无害化处理流向',
          key: 'to_things',
          ellipsis: true,
          minWidth: 180
        },
        {
          title: '救治手段',
          key: 'remark',
          ellipsis: true,
          minWidth: 180
        },
        {
          title: '操作人',
          key: 'operator',
          minWidth: 100
        },
        {
          title: '创建时间',
          key: 'ctime',
          minWidth: 150
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 150
        }

      ]
    }
  },
  created () {
    this.loadTableData()
    this.loadPigTypeData()
    this.loadPigHouseData()
    this.loadPigVarietyData()
  },
  methods: {
    loadTableData () {
      this.loading = true
      this.filter.export = 0
      pigHarmlessDeathListApi(this.filter).then(res => {
        this.tableData = res.data.list
        this.tableCount = res.data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 猪类别
    loadPigTypeData() {
      pigTypeAllApi().then(res => {
        if (res.code === 200) {
          this.pigTypeList = res.data
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    // 猪品种
    loadPigVarietyData() {
      pigVarietyAllApi().then(res => {
        if (res.code === 200) {
          this.pigVarietyList = res.data
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changePage (status) {
      this.filter.page = status
      this.loadTableData()
    },
    // 搜索
    search () {
      this.filter.page = 1
      this.loadTableData()
    },
    // 搜索清空
    searchClear () {
        this.filter.search = ''
        this.loadTableData()
    },
    // 下拉选择
    select(value){
      this.loadTableData()
    },
    // 选择时间
    dateOk(){
      this.loadTableData()
    },
    // 时间切换
    dateChange(dateArr){
      this.filter.ctime = dateArr
    },
    // 时间清空
    dateClear(){
      this.filter.ctime = []
      this.loadTableData()
    },
    // 数据导出
    exportTableData () {
      this.exportLoading = true
      this.filter.export = 1
      pigHarmlessDeathListApi(this.filter).then(res => {
        this.exportLoading = false
        if(res.code === 200){
          if (res.data.url){
            window.open(res.data.url)
          }else{
            this.$Message.error('导出失败')
          }
        }else{
          this.exportLoading = false
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.exportLoading = false
        this.$Message.error(res.msg)
      })
    },
    // 添加
    add () {
      this.$router.push({ path: this.pathFormat(this.$route.path) })
    },
    // 详情
    info (id) {
      this.$router.push({ path: this.pathFormat(this.$route.path, 'info', id) })
    },
    // 编辑
    edit (id) {
      this.$router.push({ path: this.pathFormat(this.$route.path, 'edit', id) })
    },
    // 删除
    del (id) {
      this.$Modal.confirm({
        title: '提示',
        content: '确认删除？',
        onOk: () => {
          pigHarmlessDeathDelApi(id).then(res => {
            if (res.code === 200) {
              this.$Message.success('删除成功')
              this.reload()
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      })
    },

    // 加载圈舍数据
    loadPigHouseData() {
      pigHouseAllApi().then(res => {
        if (res.code === 200) {
          this.pigHouseList = res.data
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error()
      })
    },

  }
}
</script>
